import React from 'react';
import {
    Input,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Navbar,
    Nav,
    NavLink,
    Row,
    Form, 
    FormGroup,
    Label,
} from 'reactstrap';
import NavBar from '../NavBar/navBar'
import ReactTable from "react-table";
import { connect } from "react-redux";
import {
    fetchBuilding,
    saveBuilding,
    deleteBuilding,
    fetchFloor,
    saveFloor,
    deleteFloor,
    fetchRooms,
    saveRoom,
    deleteRoom,
    saveLocation,
} from '../../actions';
import { toast, ToastContainer } from 'react-toastify';
import { NavLink as RRNavLink, withRouter } from 'react-router-dom';
import Tour from '../../Tour';
import Pagination from '../Pagination/pagination'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import { withTranslation } from 'react-i18next';
import deleteIcon from '../../assets/delete.svg'
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-toastify/dist/ReactToastify.css";
import "./addbuilding.css"
import radioButton from '../../assets/radioButton.svg'
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import "../AddFloors/addfloor.css";
import listHighlight from '../../assets/list.svg'
import list from '../../assets/list-blue.svg'
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import Draggable from 'react-draggable';

let errorDetails = ""
const initialState = {
    id: "",
    floorPlan: "",
    building: "",
    buildingId: " ",
    buildingName: "",
    floor: "",
    floorId: " ",
    floorName: "",
    roomName: "",
    roomId: " ",
    isDeleteModalOpenBuilding: false,
    isDeleteModalOpenFloor: false,
    isDeleteModalOpenRoom: false,
    deleteID: "",
    isDisable: false,
    view: true,
    type: "direct",
    floorPlanName: "",
    image: [],
    floor_name: "",
    isAddBuildingModalOpen: false,
    isAddFloorModalOpen: false,
    isAddRoomModalOpen: false,
}

class AddBuildings extends React.Component {
    constructor(props) {
        super(props)
        this.saveData = this.saveData.bind(this)
        this.resetData = this.resetData.bind(this)
        this.validateData = this.validateData.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            ...initialState,
            showBuildings: true,
            showRooms: false,
            checked: [],
            expanded: { 0: true },
        }
    }

    getBulidingColumns = () => [
        {
            Header: this.props.t('sidebar.buildingName'),
            accessor: 'building_name',
        },
        {
            Header: this.props.t('sidebar.buildingId'),
            accessor: 'building_id',
        },
        {
            Header: this.props.t('sidebar.floor'),
            id: 'floor',
            accessor: str => "floor",
            Cell: (row) => (
                <div>
                   {row.original.floors.length} {row.original.floors.length === 1 ? this.props.t('sidebar.floor') : this.props.t('sidebar.floor') + 's'}
                </div>
            ),
        },
        {
            id: 'delete',
            accessor: str => "delete",
            Cell: (row) => (
                <div className='dropdown-filter building-filter'   onClick={(e) => this.handleButtonClickBuilding(e, row.original.id, row.original.building_name)}>
                <img src={deleteIcon} alt=''/>
                </div>
            ),
            className:"delete-button-padding"
        }
    ]

    getFloorColumns = () => [
        {
            Header: this.props.t('sidebar.floorName'),
            accessor: 'floor_name',
        },
        {
            Header: this.props.t('sidebar.floorId'),
            accessor: 'floor_id',
        },
        {
            Header: this.props.t('riskManagement.floorPlan'),
            accessor: 'floor_plan',
            Cell: (row) => {
                const floorPlan = row.original.floor_plan;
                const hasFloorPlan = floorPlan && Array.isArray(floorPlan) && floorPlan.length >= 2;
                
                return (
                    <>
                        {hasFloorPlan ? (
                            <a href="#floor" style={{ display:window.innerWidth>950?'inline':'block', paddingRight: window.innerWidth>890? '5px':'10px', marginBottom: window.innerWidth>890? '0px':'5px' }} onClick={() => {
                                var image = new Image()
                                image.src = floorPlan[1]
                                this.handleImageClick(floorPlan, row.original.floor_name)
                            }}>
                                <img title={floorPlan[0]} src={floorPlan[1]} width="120" height="20" alt=""/>
                            </a>
                        ) : (
                            <span style={{ display:window.innerWidth>950?'inline':'block', paddingRight: window.innerWidth>890? '5px':'10px', marginBottom: window.innerWidth>890? '0px':'5px', color: '#999' }}>
                                {this.props.t('sidebar.noPlan')}
                            </span>
                        )}
                        <div style={{ display:window.innerWidth>950?'inline':'block' }}>
                           <button className="action-button-items"  onClick={(e) => {
                               e.preventDefault();
                               e.stopPropagation();
                               console.log('Mapear Salas clicked', row.original);
                               this.sendToMapRooms(row);
                           }}><span className="add-unit-icon">+</span> {this.props.t('sidebar.mapRooms')}</button>
                        </div>  
                    </>
                )
            },
            className: "floor-plan-column"
        },
        {
            id: 'delete',
            accessor: str => "delete",
            Cell: (row) => (
                <div className='dropdown-filter floor-filter'   onClick={(e) => this.handleButtonClickFloor(e, row.original.id, row.original.floor_name)}>
                <img src={deleteIcon} alt=""/>
                </div>
            ),
            width: 80,
            className:"delete-button-padding"
        }
    ]

    getRoomColumns = () => [
        {
            Header: this.props.t('sidebar.roomName'),
            accessor: 'room_name',
        },
        {
            Header: this.props.t('sidebar.roomId'),
            accessor: 'room_id',
        },
        {
            id: 'delete',
            accessor: str => "delete",
            Cell: (row) => (
                <div className='dropdown-filter'   onClick={(e) => this.handleButtonClickRoom(e, row.original.id, row.original.room_name)}>
                <img src={deleteIcon} alt=''/>
                </div>
            ),
            className:"delete-button-padding",
        }
    ]

    getExpanded() {
        return this.state.expanded;
    }
    
    setExpanded(e) {
        this.setState({
            expanded: e,
        });
    }

    handleCheckClick = (value) =>{
        this.setState(prevState => ({
            checked: prevState.checked.includes(value)?[...prevState.checked.filter((val) => val !== value)]:[...prevState.checked, value],
        }))
      }

    handleButtonClickBuilding = (e, id, name) => {
        this.setState(prevState => ({
            isDeleteModalOpenBuilding: !prevState.isDeleteModalOpenBuilding,
            deleteNameBuilding: name,
            deleteID: id
        }));
    }

    handleButtonClickFloor = (e, id, name) => {
        this.setState(prevState => ({
            isDeleteModalOpenFloor: !prevState.isDeleteModalOpenFloor,
            deleteNameFloor: name,
            deleteID: id
        }));
    }

    handleButtonClickRoom = (e, id, name) => {
        this.setState(prevState => ({
            isDeleteModalOpenRoom: !prevState.isDeleteModalOpenRoom,
            deleteNameRoom: name,
            deleteID: id
        }));
    }

    handleImageClick = (floor_plan,floor_name) => {
        this.setState(prevState => ({
                isImageModalOpen: !prevState.isImageModalOpen,
                image: floor_plan,
                floor_name: floor_name
         }))
    }

    componentDidMount() {
        this.props.fetchBuilding()
        this.props.fetchFloor()
        this.props.fetchRooms()
        if(Object.keys(this.props.location).includes('aboutProps')){
            if(Object.keys(this.props.location.aboutProps).includes('showBuildings')){
                this.setState({showBuildings: this.props.location.aboutProps.showBuildings, showRooms: false})
            }
            if(Object.keys(this.props.location.aboutProps).includes('showRooms')){
                this.setState({showRooms: this.props.location.aboutProps.showRooms, showBuildings: false})
            }
        }
    }

    onSelectBuilding = (event) => {
        const { value } = event.target
        this.setState({
            ...this.state,
            building: value,
        })
    }

    deleteRoom = () =>{
        this.props.deleteRoom(this.state.deleteID).then(response => {
            if(response.status === 204){
                appInsights.trackEvent({name:'Room Deleted', properties: {id: this.state.deleteID}});
                appInsights.trackTrace({message: 'Room with ID '+ this.state.deleteID+' is deleted', severityLevel: SeverityLevel.Information});
                toast.success(this.state.deleteNameRoom + " Deleted Successfully!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.setState(prevState => ({
                    isDeleteModalOpenRoom: false,
                    deleteNameRoom: "",
                    deleteID: ""
                }));
                this.props.fetchRooms()
            }
            else {
                appInsights.trackTrace({message: 'Room couldn\'t be deleted!', properties: {id: this.state.deleteID}, severityLevel: SeverityLevel.Error});
                toast.error(this.state.deleteNameRoom + " couldn't be deleted!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) =>{
            let message = this.state.deleteNameRoom + " couldn't be deleted!"
            appInsights.trackTrace({message: message, properties: {id: this.state.deleteID, error: error}, severityLevel: SeverityLevel.Error});
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    deleteFloor = () =>{
        this.props.deleteFloor(this.state.deleteID).then(response => {
            if(response.status === 204){
                appInsights.trackEvent({name: 'Floor Deleted',  properties: {id: this.state.deleteID}});
                appInsights.trackTrace({message: 'Floor with ID '+ this.state.deleteID+' is deleted', severityLevel: SeverityLevel.Information});
                toast.success(this.state.deleteNameFloor + " Deleted Successfully!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                if(parseInt(sessionStorage.getItem("floorId")) === this.state.deleteID) {
                        sessionStorage.setItem("building", "")
                        sessionStorage.setItem("buildingId", "")
                        sessionStorage.setItem("buildingName",  "")
                        sessionStorage.setItem("floorName", "")
                        sessionStorage.setItem("floorId", "")
                        sessionStorage.setItem("floor", "")
                }
                this.setState(prevState => ({
                    isDeleteModalOpenFloor: false,
                    deleteNameFloor: "",
                    deleteID: ""
                }));
                this.props.fetchFloor()
            }
            else {
                appInsights.trackTrace({message: 'Floor couldn\'t be deleted!', properties: {id: this.state.deleteID}, severityLevel: SeverityLevel.Error});
                toast.error(this.state.deleteNameFloor + " couldn't be deleted!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) =>{
            let message = this.state.deleteNameFloor + " couldn't be deleted!"
            appInsights.trackTrace({message: 'Floor couldn\'t be deleted!', properties: {id: this.state.deleteID, error: error}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
        })
    }

    deleteBuilding = () =>{
        this.props.deleteBuilding(this.state.deleteID).then(response => {
            if(response.status === 204){
                appInsights.trackEvent({name: 'Buiding Deleted',  properties: {id: this.state.deleteID}});
                appInsights.trackTrace({message: 'Buiding with ID '+ this.state.deleteID+' is deleted', severityLevel: SeverityLevel.Information});
                toast.success(this.state.deleteNameBuilding + " Deleted Successfully!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                if(parseInt(sessionStorage.getItem("buildingId")) === this.state.deleteID) {

                        sessionStorage.setItem("building", "")
                        sessionStorage.setItem("buildingId", "")
                        sessionStorage.setItem("buildingName",  "")
                        sessionStorage.setItem("floorName", "")
                        sessionStorage.setItem("floorId", "")
                        sessionStorage.setItem("floor", "")
                }
                this.setState(prevState => ({
                    isDeleteModalOpenBuilding: false,
                    deleteNameBuilding: "",
                    deleteID: ""
                }));
                this.props.fetchBuilding()
            }
            else {
                appInsights.trackTrace({message: 'Building couldn\'t be deleted!', properties: {id: this.state.deleteID}, severityLevel: SeverityLevel.Error});
                toast.error("Building couldn't be deleted!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) =>{
            let message = "Building couldn't be deleted!"
            appInsights.trackTrace({message: 'Building couldn\'t be deleted!', properties: {id: this.state.deleteID, error: error}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
        })
    }

    toggleAddBuildingModal = () => {
        this.setState(prevState => ({
            isAddBuildingModalOpen: !prevState.isAddBuildingModalOpen,
        }));
    }

    toggleAddFloorModal = () => {
        this.setState(prevState => ({
            isAddFloorModalOpen: !prevState.isAddFloorModalOpen,
        }));
    }

    toggleAddRoomModal = () => {
        this.setState(prevState => ({
            isAddRoomModalOpen: !prevState.isAddRoomModalOpen,
        }));
    }

    toggleDeleteModalBuilding = () => {
        this.setState(prevState => ({
            isDeleteModalOpenBuilding: !prevState.isDeleteModalOpenBuilding,
            deleteLocationId: ""
        }));
    }

    toggleDeleteModalFloor = () => {
        this.setState(prevState => ({
            isDeleteModalOpenFloor: !prevState.isDeleteModalOpenFloor,
            deleteLocationId: ""
        }));
    }

    toggleDeleteModalRoom = () => {
        this.setState(prevState => ({
            isDeleteModalOpenRoom: !prevState.isDeleteModalOpenRoom,
            deleteLocationId: ""
        }));
    }

    toggleImageModel = () => {
        this.setState(prevState => ({
            isImageModalOpen: !prevState.isImageModalOpen
        }))
    }

    handleChange(event) {
        if(event.target.name == ""){
            this.setState({
                ...this.state,
                ['addItem']: event.target.value
            })    
        }
        else{
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value
            })
        }
    }

    saveData = () => {
        if (this.validateData(this.state)) {    
            let createData = {
                building_id: this.state.buildingId,
                building_name: this.state.buildingName,
                building :this.state.building,
                floor_id: this.state.floorId && this.state.floorId.trim() !== "" ? this.state.floorId : undefined,
                floor_name: this.state.floorName,
                floor_plan: this.state.floorPlan,
                floor_plan_width: this.state.floor_plan_width,
                room_id :this.state.roomId,
                room_name: this.state.roomName,
            }
            // Remove undefined fields
            Object.keys(createData).forEach(key => {
                if (createData[key] === undefined) {
                    delete createData[key];
                }
            });
            
            // For floor creation, only send required fields to backend
            if (this.state.isAddFloorModalOpen) {
                const buildingId = parseInt(this.state.building);
                if (isNaN(buildingId)) {
                    toast.error("Por favor, selecione um prédio válido!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    return;
                }
                createData = {
                    building: buildingId, // Ensure it's a number
                    floor_name: this.state.floorName.trim(),
                    floor_plan: this.state.floorPlan,
                };
                // Only add floor_plan_width if it exists
                if (this.state.floor_plan_width) {
                    createData.floor_plan_width = this.state.floor_plan_width;
                }
            }
            if(this.state.isAddBuildingModalOpen){
                this.props.saveBuilding(createData).then(response => {
                        this.resetData()
                        if (response.status === 201) {
                            this.setState(prevState => ({
                                isAddBuildingModalOpen: !prevState.isAddBuildingModalOpen,
                            }));
                            appInsights.trackEvent({name: 'Buiding Added', properties:{name: response.data.building_name, id: response.data.building_id}});
                            appInsights.trackTrace({message: 'Buiding Added', properties:{name: response.data.building_name, id: response.data.building_id}, severityLevel: SeverityLevel.Information});
                            toast.success("Building  is added successfully to the list", {
                                position: toast.POSITION.BOTTOM_RIGHT
                            });
                            this.props.fetchBuilding()
                        }
                        else {
                            let message = "Building couldn't be added!"
                            appInsights.trackTrace({message: 'Building couldn\'t be added!', properties:{name: this.state.buildingName}, severityLevel: SeverityLevel.Error});
                            toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            });
                        }
                    })
                        .catch((error) => {
                            let message = "Building couldn't be added!"
                            appInsights.trackTrace({message: 'Building couldn\'t be added!', properties:{name: this.state.buildingName, error: error}, severityLevel: SeverityLevel.Error});
                            toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            })
                        })
                }
            else if(this.state.isAddFloorModalOpen){
                // createData already contains only required fields for floor creation
                this.props.saveFloor(createData).then(response => {
                    let description = this.state.buildingName + "_" + this.state.floorName +"_Unknown Room"
                    let createData = {
                        coordinates :"2,2,60,60",
                        rect_coordinates: null,
                        floor : response.data.id,
                        building : response.data.building,
                        description: description
                      }
                    this.resetData()
                    if (response.status === 201) {
                        this.props.fetchBuilding()
                        this.props.fetchRooms({room_name:"Unknown Room"}).then(response => {
                            if(response.data.length>0){
                                createData.room = response.data[0].id
                                this.props.saveLocation(createData).then(response =>{
                                    appInsights.trackEvent({name: 'Unknown room added', properties:{name: response.data, id: response.data.floor_id}});
                                })
                            }
                            else{
                                this.props.saveRoom({room_name:"Unknown Room",room_id:" "}).then(response => {
                                    if(response.status == 201){
                                        createData.room = response.data.id
                                        this.props.saveLocation(createData).then(response =>{
                                            appInsights.trackEvent({name: 'Unknown room added', properties:{name: response.data, id: response.data.floor_id}});
                                        })
                                    }
                                })
                            }
                            this.props.fetchRooms()
                        })
                        this.setState(prevState => ({
                            isAddFloorModalOpen: !prevState.isAddFloorModalOpen,
                        }));
                        appInsights.trackEvent({name: 'Floor Added', properties:{name: response.data.floor_name, id: response.data.floor_id}});
                        appInsights.trackTrace({message: 'Floor Added', properties:{name: response.data.floor_name, id: response.data.floor_id}, severityLevel: SeverityLevel.Information});
                        toast.success("Floor is added successfully to the list", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        this.props.fetchFloor()
                    }
                    else {
                        appInsights.trackTrace({message: 'Floor couldn\'t be added!', properties:{id: this.state.floorId, name: this.state.floorName}, severityLevel: SeverityLevel.Error});
                        let message = "Floor couldn't be added!"
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                })
                    .catch((error) => {
                        console.error('Error creating floor:', error);
                        let errorMessage = "Floor couldn't be added!";
                        if (error.response && error.response.data) {
                            // Try to extract a more specific error message
                            const errorData = error.response.data;
                            if (typeof errorData === 'string') {
                                errorMessage = errorData;
                            } else if (errorData.detail) {
                                errorMessage = errorData.detail;
                            } else if (errorData.error) {
                                errorMessage = errorData.error;
                            } else if (errorData.message) {
                                errorMessage = errorData.message;
                            }
                        }
                        appInsights.trackTrace({message: 'Floor couldn\'t be added!', properties:{id: this.state.floorId, name: this.state.floorName, error: error}, severityLevel: SeverityLevel.Error});
                        toast.error(errorMessage, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            autoClose: 5000
                        })
                    })
            }
            else if(this.state.isAddRoomModalOpen){
                this.props.saveRoom(createData).then(response => {
                    this.resetData()
                    if (response.status === 201) {
                        this.setState(prevState => ({
                            isAddRoomModalOpen: !prevState.isAddRoomModalOpen,
                        }));
                        appInsights.trackEvent({name:'Room Added', properties:{name: response.data.room_name, id: response.data.room_id}});
                        appInsights.trackTrace({message:'Room Added', properties:{name: response.data.room_name, id: response.data.room_id}, severityLevel: SeverityLevel.Information});
                        toast.success( "Room is added successfully to the list", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        this.props.fetchRooms()
                    }
                    else {
                        let message = "Rooms couldn't be added!"
                        appInsights.trackTrace({message: message, properties:{id: this.state.roomId, name: this.state.roomName}, severityLevel: SeverityLevel.Error});
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                })
                .catch((error) => {
                    let message = "Room couldn't be added!"
                    appInsights.trackTrace({message: message, properties:{id: this.state.roomId, name: this.state.roomName, error: error}, severityLevel: SeverityLevel.Error});
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                })
            }
        }                
    else {
        this.ErrorDetails()
    }
}
    ErrorDetails = () => {
        appInsights.trackTrace({message: errorDetails, severityLevel: SeverityLevel.Verbose});
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    handleFormSubmit = (e) => { 
        e.preventDefault(); 
        this.saveData();
    }

    resetData = () => {
        this.setState({
            buildingId: "", 
            buildingName: "",
            floorId: "", 
            floorName: "", 
            building:"", 
            floorPlanName:"", 
            floorPlan: null, 
            roomId: "", 
            roomName: "",
            image: null
        })
    } 

    cancelData = () => {
        this.setState(initialState)
    }

    validateData = (data) => {
        if (data.buildingName.trim().length > 0) {
            return true
        }
        else if(data.floorName.trim().length > 0 && data.building && data.floorPlan){
            return true
        }
        else if(data.roomName.trim().length > 0){
            for(let val of this.props.rooms){
                if(val['room_name'] == data.roomName){
                    errorDetails = "Room already exists! Please enter a new room name!"
                    return false
                }
            }
            return true
        }
        else if (!data.building) {
            errorDetails = "All *mandatory fields are required!"
            return false
        }
        else if (!data.floorPlan) {
            errorDetails = "Upload a FloorPlan!"
            return false
        }
        else if (!data.floorName) {
            errorDetails = "Floor Name is required to create a Floor!"
            return false
        }
        else if (!data.roomName) {
            errorDetails = "Room Name is required to create a Room!"
            return false
        }
        else {
            errorDetails = "All *mandatory fields are required!"
            return false
        }
    }

    handleError = (err) => {
        console.error(err)
    }

    componentWillUnmount() {
        // Clean up object URLs to prevent memory leaks
        if (this.state.image) {
            URL.revokeObjectURL(this.state.image);
        }
    }

    onChangeFile = event => {
        const file = event.target.files[0];
        if (file) {
            // Clean up previous object URL if exists
            if (this.state.image) {
                URL.revokeObjectURL(this.state.image);
            }
            this.setState({
                floorPlan: file,
                floorPlanName: file.name,
                image: URL.createObjectURL(file)
            })
        }
    }

    onImageLoad = event => {
        let floor_width = 1268
        this.setState({
            floor_plan_width: floor_width<event.target.naturalWidth?floor_width:event.target.naturalWidth
        })
    }

    sendToMapRooms = (buildFloor) => {
        console.log('sendToMapRooms called', buildFloor);
        if (!buildFloor || !buildFloor.original) {
            console.error('Invalid buildFloor data:', buildFloor);
            return;
        }
        
        if (!this.props.history) {
            console.error('History not available');
            return;
        }
        
        let buildingToShow = buildFloor.original.building?.id || buildFloor.original.building_id;
        let floorToShow = buildFloor.original.id || buildFloor.original.floor_id;
        let buildingName = buildFloor.original.building?.building_name || buildFloor.original.building_name;
        let floorName = buildFloor.original.floor_name;
        let floorId = buildFloor.original.floor_id;
        let buildingId = buildFloor.original.building?.building_id || buildFloor.original.building_id;
        
        console.log('Navigating to /manage/addLocations with:', {
            buildingToShow,
            floorToShow,
            buildingName,
            floorName,
            floorId,
            buildingId
        });
        
        this.props.history.push({
            pathname: "/manage/addLocations",
            state: {
                buildingToShow: buildingToShow, 
                floorToShow: floorToShow, 
                buildingName: buildingName, 
                floorName: floorName,
                floorId: floorId,
                buildingId: buildingId,
            }
        });
    }

    openRoomModal = () => {
        if(!this.state.showRooms){
            this.setState(prevState => ({
                showRooms: !prevState.showRooms,
                showBuildings: false,
            }));
        }
    }
    openBuildingModal = () => {
        if(!this.state.showBuildings){
            this.setState(prevState => ({
                showBuildings: !prevState.showBuildings,
                showRooms: false,
            }));
        }
    }

    floorFilter = (floors, building, index) => {
        let filteredFloors = []
        floors.map((floor) =>  {
            if(floor.building.building_name===building[index]['building_name']){
                filteredFloors.push(floor)
            }
        })
        return filteredFloors
    }

    render() {
        return(
            <>
            <div data-tut="reactour__manage" className="manage-page page-layout">
                <NavBar />
                <div className={window.innerWidth > 900 ? "dashboard-overview samples-page" : "dashboard-overview-100 samples-page"}>
                    <div className="dashboard-content-25 ">
                        <Row className="manage-page-header mt-0" form>
                            <Navbar className="navbar-results " light expand="md">
                                <Nav navbar>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt=''/>{this.props.t('sidebar.manageLocations')}</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/locations"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>{this.props.t('sidebar.viewLocations')}</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/notifications/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>{this.props.t('sidebar.manageNotifications')}</span></NavLink>
                                </Nav>
                            </Navbar>
                        </Row>
                    </div>
                    <div className="sample-list-header building-heading grid-data remove-space">
                        <NavLink onClick={this.openBuildingModal} className="open-building-modal default-cursor" style={{color: this.state.showBuildings ? '#F38238DB' : '#6676AA', borderBottom: this.state.showBuildings? '4px solid #ee7d11':'', borderRadius: this.state.showBuildings?'4px':'' }}>
                            {this.state.showBuildings?
                                <img src={listHighlight} className="nav-icons" alt=''/>:
                                <img src={list} className="nav-icons" alt=''/>
                            }    
                            {this.props.t('sidebar.buildingsAndFloors')}
                        </NavLink>
                        <NavLink onClick={this.openRoomModal} className="open-room-modal default-cursor" style={{color: this.state.showRooms? '#F38238DB' : '#6676AA', borderBottom: this.state.showRooms? '4px solid #ee7d11':'', borderRadius: this.state.showRooms?'4px':''  }}>
                            {this.state.showRooms?
                                <img src={listHighlight} className="nav-icons" alt=''/>:
                                <img src={list} className="nav-icons" alt=''/>
                            }
                            {this.props.t('sidebar.rooms')}
                        </NavLink> 
                        <Row form data-tut="reactour__apply" className="action-buttons">
                            <div value={this.state.addItem}>
                                {this.state.showBuildings? 
                                    <>
                                        <button className="action-button-items" value="AddBuilding" onClick={(e) => { this.handleChange(e); this.toggleAddBuildingModal(); }}><span className="add-unit-icon">+</span> {this.props.t('sidebar.building')}</button>
                                        <button className="action-button-items" value="AddFloor" onClick={(e) => { this.handleChange(e); this.toggleAddFloorModal(); }}><span className="add-unit-icon">+</span> {this.props.t('sidebar.floor')}</button>
                                    </>
                                :null}
                                {this.state.showRooms? 
                                    <button className="action-button-items" value="AddRoom" onClick={(e) => { this.handleChange(e); this.toggleAddRoomModal(); }}><span className="add-unit-icon">+</span> {this.props.t('sidebar.room')}</button>
                                :null}        
                            </div>
                        </Row>
                    </div>
                    { this.state.showBuildings? 
                        <div className="grid-data remove-top-space" data-tut="reactour__table">
                            {this.props.buildingList && this.props.buildingList.length > 0 ?
                                <div className="location-table-height" >
                                    <ReactTable className="Data-Table tables-height"
                                        data={this.props.buildingList}
                                        columns={this.getBulidingColumns()}
                                        showPagination={this.props.buildingList.length>5? true: false}
                                        PaginationComponent={Pagination}
                                        defaultPageSize={5}
                                        expanded={this.getExpanded()}
                                        onExpandedChange={e => {
                                            this.setExpanded(e);
                                        }}
                                        minRows={0}
                                        sortable={false}
                                        SubComponent={row => {
                                            return (
                                                <>
                                                    {row.original.floors.length > 0?  
                                                        <div className="nested-sub-table">
                                                            <ReactTable className="Data-Table tables-height"
                                                                data={this.floorFilter(this.props.floors, this.props.buildingList, row.index)}
                                                                columns={this.getFloorColumns()}
                                                                showPagination={false}
                                                                minRows={0}
                                                                sortable={false}
                                                            />
                                                        </div>
                                                    :
                                                    <div className="no-data-msg"> No Floors available for this building yet.</div>
                                                    }
                                                </>
                                            )}
                                        }       
                                    />
                                </div>
                                : <div className="no-data-msg"> No Buildings Available</div>
                            }
                        </div>
                    : null}
                    {this.state.showRooms? 
                        <div className="grid-data remove-top-space" data-tut="reactour__tableRoom">
                                {this.props.rooms && this.props.rooms.length > 0 ?
                                    <div className="location-table-height" >
                                        <ReactTable className="Data-Table tables-height"
                                            data={this.props.rooms}
                                            columns={this.getRoomColumns()}
                                            defaultPageSize={10}
                                            showPagination={true}
                                            PaginationComponent={Pagination}
                                            minRows={0}
                                            sortable={false}
                                        />
                                    </div>
                                : <div className="no-data-msg"> {this.props.t('sidebar.noRoomsAvailable')}</div>
                            }
                        </div>
                    :null}
                </div>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isAddBuildingModalOpen} toggle={this.toggleAddBuildingModal}>
                    <ModalHeader toggle={this.toggleAddBuildingModal} className="edit-popup hover-move">{this.props.t('sidebar.addABuilding')}</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={this.handleFormSubmit}>
                            <FormGroup>
                                <Label className="location-label-names">{this.props.t('sidebar.buildingName')}<span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="text" name="buildingName" id="BuildingName" value={this.state.buildingName} onChange={this.handleChange} size="1" placeholder="Ex: Building A" />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter className="float-sm-right bottom-options">
                        <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={() => this.resetData()}>{this.props.t('common.cancel')}</Button>
                        <Button className="button-size custom-button save-upload-delete-button" id="save" onClick={() => this.saveData()}>{this.props.t('common.save')}</Button>
                    </ModalFooter>
                </Modal>
                </Draggable>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isAddFloorModalOpen} toggle={this.toggleAddFloorModal}>
                    <ModalHeader toggle={this.toggleAddFloorModal} className="edit-popup hover-move">{this.props.t('sidebar.addAFloor')}</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={this.handleFormSubmit}>
                            <FormGroup>
                                <Label className="location-label-names">{this.props.t('sidebar.building')} <span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="select" name="building" id="Building" value={this.state.building} onChange={this.handleChange} size="1">
                                    <option value="" default disabled>{this.props.t('sidebar.building')}</option>
                                    {this.props.buildingList.map((building, key) => {
                                        return <option id={building.building_id} key={key} value={building.id}>{building.building_name}</option>
                                    })}
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label className="location-label-names">{this.props.t('sidebar.floorName')}<span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="text" name="floorName" id="FloorName" value={this.state.floorName} onChange={this.handleChange} size="1" placeholder="Ex: Floor 1" />
                            </FormGroup>
                            <FormGroup>
                                <FontAwesomeIcon className="overlay-upload-icon upload-icon-position"  icon={faUpload} size="lg" />
                                <Input
                                    className="edit-input-values edit-input-values-file input-upload"
                                    type="file"
                                    accept='image/*'
                                    placeholder="please enter file"
                                    onChange={this.onChangeFile}
                                    key={this.state.floorPlanName || 'file-input'}
                                    data-title={this.state.floorPlanName || 'Upload Floorplan Image*'}
                                />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter className="float-sm-right bottom-options">
                        <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={() => this.resetData()}>{this.props.t('common.cancel')}</Button>
                        <Button className="button-size custom-button save-upload-delete-button" id="save" onClick={() => this.saveData()}>{this.props.t('common.save')}</Button>
                    </ModalFooter>
                </Modal>
                </Draggable>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isAddRoomModalOpen} toggle={this.toggleAddRoomModal}>
                    <ModalHeader toggle={this.toggleAddRoomModal} className="edit-popup hover-move">{this.props.t('sidebar.addARoom')}</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={this.handleFormSubmit}>
                            <FormGroup>
                                <Label className="location-label-names">{this.props.t('sidebar.roomName')}<span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="text" name="roomName" id="RoomName" value={this.state.roomName} onChange={this.handleChange} size="1" placeholder="Ex: Cold Room 1" />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter className="float-sm-right bottom-options">
                        <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={() => this.resetData("Room")}>{this.props.t('common.cancel')}</Button>
                        <Button className="button-size custom-button save-upload-delete-button" id="save" onClick={() => this.saveData("Room")}>{this.props.t('common.save')}</Button>
                    </ModalFooter>
                </Modal>
                </Draggable>

                <Modal isOpen={this.state.isDeleteModalOpenBuilding} toggle={this.toggleDeleteModalBuilding}>
                    <ModalHeader toggle={this.toggleDeleteModalBuilding} className="edit-popup delete-title">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle}/>
                        {this.props.t('sidebar.deleteBuilding')}
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        {this.props.t('common.areYouSureDelete')} <i>{this.state.deleteNameBuilding}</i> ?
                        <div className="edit-popup-message"><span className="required-icon">{this.props.t('common.warning')}: </span>
                            {this.props.t('common.deleteBuildingWarning')}</div>
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                            <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.toggleDeleteModalBuilding}>{this.props.t('common.cancel')}</Button>
                            <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteBuilding}>{this.props.t('common.delete')}</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.isDeleteModalOpenFloor} toggle={this.toggleDeleteModalFloor}>
                    <ModalHeader toggle={this.toggleDeleteModalFloor} className="edit-popup delete-title">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle}/>
                        {this.props.t('sidebar.deleteFloor')}
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        {this.props.t('common.areYouSureDelete')} <i>{this.state.deleteNameFloor}</i> ?
                        <div className= "edit-popup-message"><span className="required-icon">{this.props.t('common.warning')}: </span>
                            {this.props.t('common.deleteFloorWarning')}</div>
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                        <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.toggleDeleteModalFloor}>{this.props.t('common.no')}</Button>
                        <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteFloor}>{this.props.t('common.yes')}</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.isDeleteModalOpenRoom} toggle={this.toggleDeleteModalRoom}>
                    <ModalHeader toggle={this.toggleDeleteModalRoom} className="edit-popup delete-title">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle}/>
                        {this.props.t('sidebar.deleteRoom')}
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        {this.props.t('common.areYouSureDelete')} <i>{this.state.deleteNameRoom}</i>?
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                        <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.toggleDeleteModalRoom}>{this.props.t('common.no')}</Button>
                        <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteRoom}>{this.props.t('common.yes')}</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.isImageModalOpen} toggle={this.toggleImageModel}>
                    <ModalHeader toggle={this.toggleImageModel} className="edit-popup">{this.state.floor_name}</ModalHeader>
                    <ModalBody>
                        <img title={this.state.image[0]} src={this.state.image[1]} width="100%" alt=''/>
                    </ModalBody>
                </Modal>

                <ToastContainer autoClose={3000} />
                {this.props.isTourOpen?<Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} />:null}
                {this.state.addItem ==="AddFloor" ?
                    this.props.history.push("/manage/buildings/addFloors")
                    :
                    this.state.addItem ==="AddRoom" ?
                        this.props.history.push("/manage/buildings/addRooms")
                        :null
                }
            </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        buildingList: state.floor_data.buildingsList,
        buildingPagination: state.floor_data.buildingPagination,
        buildingParams: state.floor_data.buildingParams,
        floorsList:  state.floor_data.floorsList,
        floors: state.floor_data.floors,
        floorPagination: state.floor_data.floorPagination,
        floorParams: state.floor_data.floorParams,
        rooms: state.floor_data.rooms,
        roomPagination: state.floor_data.roomPagination,
        roomParams: state.floor_data.roomParams,
    }
}

export default withAITracking(reactPlugin, withRouter(withTranslation()(connect(
    mapStateToProps,
    {
        fetchBuilding,
        saveBuilding,
        deleteBuilding,
        fetchFloor,
        saveFloor,
        deleteFloor,
        fetchRooms,
        saveRoom,
        deleteRoom,
        saveLocation,
    }
)(AddBuildings))), 'Manage Buildings', 'AddBuildings');